import { createAction } from 'redux-actions';

export const showAuth = createAction('MENU:AUTH_SHOW');
export const hideAuth = createAction('MENU:AUTH_HIDE');
